import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { LibraryContent } from '../../components/Pleri/components/Library';

export const Route = createFileRoute('/quick-start/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <LibraryContent />;
}
